import { useEffect } from "react";
import { create } from "zustand";
import { shallow } from "zustand/shallow";
import { useAuthStore } from "./authStore";
import { useClustersQuery } from "../queries/community";
import { ClusterData } from "../queries/community.types";

type CommunityClusterActions = {
  readonly setCurrentCluster: (props?:ClusterData) => void
  readonly setAvailableClusters: (props: ClusterData[]) => void
}

type CommunityClusterStore = {
  currentCluster?: ClusterData,
  availableClusters: ClusterData[]
}


export const useCommunityClusterStore = create<CommunityClusterStore & CommunityClusterActions>((set) => ({
  availableClusters: [],
  setCurrentCluster:(cluster?: ClusterData) => set({ currentCluster: cluster }),
  setAvailableClusters: (clusters: ClusterData[]) => set({ availableClusters: clusters })
}));

export const useCurrentCommunityCluster = () => {
  const { currentCluster, availableClusters, setAvailableClusters, setCurrentCluster } = useCommunityClusterStore();
  const enableCommunityFlag = useAuthStore(state => state.corporateInfo?.enable_community_flag && state.smartConfiguration?.funcCommunity, shallow);
  const { data, isLoading, error, failureCount, isFetching } =  useClustersQuery({ enabled: enableCommunityFlag });
  useEffect(() => {
    if(!currentCluster && availableClusters.length === 0 && (data?.output?.length ?? 0) > 0) {
      setAvailableClusters(data?.output.map(({ cluster }) => cluster)??[]);
      setCurrentCluster(data?.output?.[0].cluster);
    }
  }, [data, currentCluster, availableClusters, setAvailableClusters, setCurrentCluster]);
  return { isLoading, error, availableClusters, currentCluster, failureCount, isFetching };
};
